import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import Config from "./core/config";

const firebaseConfig = {
    apiKey: Config.FIREBASE.APIKEY,
    authDomain: Config.FIREBASE.AUTHDOMAIN,
    projectId: Config.FIREBASE.PROJECTID,
    storageBucket: Config.FIREBASE.STORAGEBUCKET,
    messagingSenderId: Config.FIREBASE.MESSAGINGSENDERID,
    appId: Config.FIREBASE.APPID,
    measurementId: Config.FIREBASE.MEASUREMENTID
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();